// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_DateButtons_container__Z1GQw {
  display: flex;
  gap: 8px;
}

.storage_DateButtons_button__lvYsN {
  min-width: auto;
  height: 30px;
  min-height: 30px;
  padding: 6px 16px;
  border: none;
  border-radius: 2px;
  box-shadow: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}

.storage_DateButtons_selected__cj6ZN {
  color: var(--color-white);
}
`, "",{"version":3,"sources":["webpack://./src/components/DateButtons/DateButtons.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  gap: 8px;\n}\n\n.button {\n  min-width: auto;\n  height: 30px;\n  min-height: 30px;\n  padding: 6px 16px;\n  border: none;\n  border-radius: 2px;\n  box-shadow: none;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.selected {\n  color: var(--color-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `storage_DateButtons_container__Z1GQw`,
	"button": `storage_DateButtons_button__lvYsN`,
	"selected": `storage_DateButtons_selected__cj6ZN`
};
export default ___CSS_LOADER_EXPORT___;
